import React from "react";
import { Button } from "../components/ui/button";
import { LOGOS, BG } from "../lib/brand";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate flex min-h-[88vh] items-center overflow-hidden"
    >
      {/* Background texture */}
      <div
        className="absolute inset-0 -z-10 bg-cover bg-center opacity-40"
        style={{ backgroundImage: `url(${BG.heroTexture})` }}
      />
      <div className="absolute inset-0 -z-10 bg-black/70" />
      <div className="absolute inset-0 -z-10 kf-grain opacity-50" />
      <div className="absolute inset-0 -z-10 kf-vignette" />

      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-12 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:px-8">
        {/* Left: copy */}
        <div className="fade-up">
          <div className="mb-4 inline-flex items-center gap-2 border border-[#E11D2A]/40 bg-[#E11D2A]/10 px-3 py-1 text-xs uppercase tracking-[0.25em] text-[#E11D2A]">
            <span className="inline-block h-1.5 w-1.5 bg-[#E11D2A]" /> Card Shop · Board Games · Boba
          </div>
          <h1
            data-testid="hero-headline"
            className="font-display text-5xl leading-[0.95] tracking-widest text-[#F5F5DC] sm:text-6xl lg:text-7xl xl:text-8xl"
          >
            Shuffle. Sip.
            <br />
            <span className="text-[#E11D2A]">Play.</span>
          </h1>
          <p className="mt-6 max-w-xl text-base text-[#A1A1AA] sm:text-lg">
            Your dojo for trading card games, board game nights, and dangerously
            delicious boba. Step inside Kung Fu TCG — where every move counts.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Button
              data-testid="hero-shop-cta-button"
              onClick={() => scrollTo("shop")}
              className="rounded-none bg-[#E11D2A] px-8 py-6 text-base font-semibold uppercase tracking-widest text-white hover:bg-[#F02D3A] hover:-translate-y-0.5 transition-transform"
            >
              Shop Now
            </Button>
            <Button
              data-testid="hero-visit-cta-button"
              variant="outline"
              onClick={() => scrollTo("visit")}
              className="rounded-none border-[#F5F5DC]/30 bg-transparent px-8 py-6 text-base font-semibold uppercase tracking-widest text-[#F5F5DC] hover:bg-[#F5F5DC]/10 hover:text-[#F5F5DC]"
            >
              Enter the Dojo
            </Button>
          </div>

          <div className="mt-12 grid max-w-md grid-cols-3 gap-6 border-t border-[#27272A] pt-6">
            <Stat label="TCG Singles" value="1k+" />
            <Stat label="Board Games" value="50+" />
            <Stat label="Boba Drinks" value="30+" />
          </div>
        </div>

        {/* Right: mascot */}
        <div className="relative flex items-center justify-center">
          <div className="absolute -inset-8 -z-10 bg-[#E11D2A]/20 blur-3xl" />
          <img
            src={LOGOS.mascotFull}
            alt="Kung Fu TCG Master"
            className="relative w-full max-w-md lg:max-w-lg drop-shadow-[0_30px_60px_rgba(225,29,42,0.35)]"
          />
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div className="font-display text-3xl tracking-wider text-[#E11D2A]">{value}</div>
      <div className="mt-1 text-xs uppercase tracking-widest text-[#A1A1AA]">{label}</div>
    </div>
  );
}
